import { Injectable } from '@angular/core';
import { createAction, props } from '@ngrx/store';

@Injectable()
export class ConnectionProfilesActions {

    static openConnectionProfileDialog =
        createAction('[Satellite:Setup:ConnectionProfile]  Open Connection Profile Dialog', props<{autoremindAccount: any, selectedConnectionProfile: any}>());

    static getConnectionProfiles =
        createAction('[Satellite:Setup:ConnectionProfile]  Get Connection Profiles');

    static getConnectionProfilesSuccess =
        createAction('[Satellite:Setup:ConnectionProfile]  Get Connection Profiles Success' , props<{connectionProfiles: Array<any>}>());

    static getConnectionProfilesFail =
        createAction('[Satellite:Setup:ConnectionProfile]  Get Connection Profiles Fail' , props<{error: any}>());

    static updateConnectionProfiles =
        createAction('[Satellite:Setup:ConnectionProfile]  Update Connection Profiles', props<{autoremindAccount: any, selectedConnectionProfileId: any}>());

    static updateConnectionProfilesSuccess =
        createAction('[Satellite:Setup:ConnectionProfile]  Update Connection Profiles Success');

    static updateConnectionProfilesFail =
        createAction('[Satellite:Setup:ConnectionProfile]  Update Connection Profiles Fail' , props<{error: any}>());

}
